import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Array
import kotlin.Boolean
import kotlin.Double
import kotlin.String
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface TravelInfoControllerTargetLifecycleHooks {
  public fun infoTargetConnected(element: HTMLElement) {
  }

  public fun infoTargetDisconnected(element: HTMLElement) {
  }

  public fun latitudeValueChanged(`value`: Double, previousValue: Double) {
  }

  public fun longitudeValueChanged(`value`: Double, previousValue: Double) {
  }

  public fun travelUrlValueChanged(`value`: String, previousValue: String) {
  }
}

public fun <T : HTMLElement> TravelInfoController.infoTarget(): StimulusProperty<T> =
    StimulusProperty("infoTarget")

public fun <T : HTMLElement> TravelInfoController.infoTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("infoTargets")

public fun TravelInfoController.latitudeValue(): StimulusProperty<Double> =
    StimulusProperty("latitudeValue")

public fun TravelInfoController.hasLatitudeValue(): Boolean {
  println(this.asDynamic()["hasLatitudeValue"])
  return this.asDynamic()["hasLatitudeValue"]
}

public fun TravelInfoController.longitudeValue(): StimulusProperty<Double> =
    StimulusProperty("longitudeValue")

public fun TravelInfoController.hasLongitudeValue(): Boolean {
  println(this.asDynamic()["hasLongitudeValue"])
  return this.asDynamic()["hasLongitudeValue"]
}

public fun TravelInfoController.travelUrlValue(): StimulusProperty<String> =
    StimulusProperty("travelUrlValue")

public fun TravelInfoController.hasTravelUrlValue(): Boolean {
  println(this.asDynamic()["hasTravelUrlValue"])
  return this.asDynamic()["hasTravelUrlValue"]
}

public fun registerTravelInfoController(stimulus: Application) {
               val clazz = TravelInfoController::class
               val properties = object  {
                  // Js name needed otherwise Kotlin will mangle the name
                  @JsName("targets")
                  val targets = js("['info']")

                  @JsName("values")
                  val values = buildValues(
                      setOf(
                          ValueDefinition("latitude", "Number", false),
  ValueDefinition("longitude", "Number", false),
  ValueDefinition("travelUrl", "String", false)
                      ),
                      TravelInfoController.Values
                  )
                  
                  
                  
                  @JsName("classes")
                  val classes = js("[]")
              }

              val factoryFunc = clazz.js.asDynamic()

              addStaticMembersTo(factoryFunc, properties)
              val controllerName = "travelinfo"
              println("Registering controller travelinfo")

              stimulus.register(controllerName, factoryFunc)
}
